export const AllCircuits = () => {
  return (
    <div className="fixed inset-0 z-50 bg-black/60">
      <iframe
        title="All Circuits"
        src="/all-circuits/index.html"
        className="h-full w-full border-none bg-white"
      />
    </div>
  );
};
